import { Avatar } from "primereact/avatar";
import { Dialog } from "primereact/dialog";
import React from "react";
import { useFormik, FormikProvider } from "formik";
import Input from "../forms/Input";
import Select from "../forms/Select";

interface Props {
  show: boolean;
  onHide: () => void;
  user: any;
}

export default function Profile({ show, onHide, user }: Props) {
  const formik = useFormik({
    initialValues: {
      ...user,
    },
    enableReinitialize: true,
    onSubmit: (values: any) => {},
  });

  const { values } = formik;

  return (
    <Dialog
      visible={show}
      onHide={onHide}
      header="Profile"
      style={{ width: "50vw" }}
      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      blockScroll={true}
    >
      <div className="flex flex-column gap-5">
        <section className="flex justify-content-center">
          <Avatar label={user.initials} size="xlarge" />
        </section>

        <FormikProvider value={formik}>
          <div className="flex flex-column gap-4">
            <section className="flex flex-row gap-4 grid">
              <Input id="firstname" label="First Name" disabled />
              <Input id="lastname" label="Last Name" disabled />
            </section>

            <Input id="email" icon="pi pi-envelope" label="Email" disabled />

            <Input
              id="phone"
              icon="pi pi-phone"
              label="Phone Number"
              disabled
            />

            <Select
              id="role"
              placeholder="Select Role"
              label="Role"
              isRequired
              options={[
                { label: "Super Admin", value: "Super Admin" },
                { label: "Inputer", value: "Inputer" },
              ]}
              optionLabel="label"
              disabled
            />
          </div>
        </FormikProvider>
      </div>
    </Dialog>
  );
}
